export const onPageLoadGtmEvent = () => {
  const eventName = 'gatsby-page-view'

  window.dataLayer.push({ event: eventName })
}

export const onRouteUpdateGtmEvent = (pluginOptions) => {
  const data = pluginOptions.dataLayerName
    ? window[pluginOptions.dataLayerName]
    : window.dataLayer
  const eventName = pluginOptions.routeChangeEventName
    ? pluginOptions.routeChangeEventName
    : `gatsby-route-change`

  data.push({ event: eventName })
}
